import logo from '../assets/images/psb-logo-animated.gif';

export default function PageLoading() {
  return (
    <div className={'loading mt-5'}>
      <p className={'text-center'}>
        <img
          style={{
            width: '65px',
            height: '60px',
            margin: '-15px 25px 10px 20px',
            position: 'absolute',
            top: '40vh',
          }}
          src={logo} className={'logo-sm logo'}/>
    </p>
</div>
)
  ;

}